import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { extractTableHeaders } from 'utils/hooks/reportTableUtils';
import { BProps, DataTypeB0601 } from 'store/ducks/Reportings/types';
import { columnsB0601 } from 'constants/reportColumns';

const B0601: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0601[]>([]);
  const memoizedColumns = useMemo(() => columnsB0601, [columnsB0601]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchRT0601(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            function_identifier: dataItem['Function identifier'],
            licenced_identifier: dataItem['Licenced activity'],
            function_name: dataItem['Function name'],
            lei_of_financial_entity: dataItem['LEI of the financial entity'],
            criticality_assessment: dataItem['Criticality assessment'],
            reasons_for_criticality: dataItem['Reasons for criticality'],
            date_of_last_assessment:
              dataItem['Date of the last assessment of criticality'],
            recovery_time_objective:
              dataItem['Recovery time objective of the function'],
            recovery_point_objective:
              dataItem['Recovery point objective of the function'],
            impact_of_discontinuing_function:
              dataItem['Impact of discontinuing the function'],
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  useEffect(() => {
    extractTableHeaders(memoizedColumns, dispatch);
  }, []);

  return (
    <>
      <Table
        columns={columnsB0601}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0601;
